import { fetchWrapperPublic } from "helpers/fetch-wrapper";
import { API_BASE_URL } from "helpers/constants";

export class ProductRequests {
    static async createProduct(
        data: any // would define elsewhere
    ): Promise<Response> {
        return await fetchWrapperPublic.post(
            `${API_BASE_URL}/business/xd`, data
        );
    }

    static async getProducts(): Promise<Response> {
        return await fetchWrapperPublic.get(
            `${API_BASE_URL}/business/xd`
        );
    }

    static async updateProduct(
        productId: string,
        data: any
    ): Promise<Response> {
        return await fetchWrapperPublic.patch(
            `${API_BASE_URL}/business/${productId}`, data
        );

    }

    static async deleteProduct(
        productId: string
    ): Promise<Response> {
        return await fetchWrapperPublic.delete(
            `${API_BASE_URL}/business/${productId}`
        );
    }

    static async setAvailability(
        data: any
    ): Promise<Response> {
        return await fetchWrapperPublic.post(
            `${API_BASE_URL}/business/products/set-availability`, data
        );
    }
}